import React, { useEffect, useMemo, useRef } from 'react';
import useIntersectionObserver from '../../../customHooks/useIntersectionObserver';

const LazySection = ({ children, onVisible, deps = [], rootMargin = '100px' }) => {
  const options = useMemo(() => ({
    root: null,
    rootMargin,
    threshold: 0.1
  }), [rootMargin]);

  const { elementRef, isVisible } = useIntersectionObserver(options, deps);
  const onVisibleRef = useRef(onVisible);
  onVisibleRef.current = onVisible;

  // When section becomes visible, run the latest callback once. Parent often passes an
  // inline onVisible — it must not be a useEffect dependency or every re-render refires fetches.
  useEffect(() => {
    if (!isVisible) return;
    const fn = onVisibleRef.current;
    if (typeof fn === 'function') fn();
  }, [isVisible]);

  return (
    <div ref={elementRef} className="lazy-section-wrapper transition-opacity duration-300">
      {children}
    </div>
  );
};

export default LazySection;
